import { render, staticRenderFns } from "./ReportImageTuev.vue?vue&type=template&id=5f095002&scoped=true"
import script from "./ReportImageTuev.vue?vue&type=script&lang=ts"
export * from "./ReportImageTuev.vue?vue&type=script&lang=ts"
import style0 from "./ReportImageTuev.vue?vue&type=style&index=0&id=5f095002&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f095002",
  null
  
)

export default component.exports